import React, { useState, useEffect } from 'react';
import moment from 'moment';

const Timer = (props) => {
  const { startDate, paidMinutes, reverse=false } = props;

  const beginTime = moment().diff(moment(startDate), 'seconds'); // minutos decorridos até agora
  const endTime = paidMinutes*60;

  const [seconds, setSeconds] = useState( reverse ? endTime-beginTime : beginTime );

  const tick = () => {
    if (seconds > 0 && seconds <= endTime)
      setSeconds( reverse ? seconds-1 : seconds+1 );
  }

  useEffect(() => {
    const interval = setInterval(() => tick(), 1000);
    return () => clearInterval(interval);
  }, [seconds]);

  return (
    <div>{ moment.utc(seconds*1000).format("HH:mm:ss") }</div>
  )

}

export default Timer;
